module.exports = __webpack_public_path__ + "img/不及格.51d023da.png";